import React from 'react';
import axios from 'helpers/axios';

import { Form, Container, Title, TextInput, Button, Label, Select } from 'ui/components/styled';
import { ValidationPattern } from 'helpers/form';
import { useToasts, useCompany } from 'hooks';

export const AddCategory = ({
  onClose,
  onSuccess,
  submitButtonText = 'Save',
  submitButtonWidth = '30%',
}) => {
  const { companiesOptions, activeCompany } = useCompany();
  const [state, setState] = React.useState({ name: '', company: activeCompany });
  const [preventSubmit, setPreventSubmit] = React.useState(false);
  const { errorToast, successToast, removeAllToasts } = useToasts();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((state) => ({ ...state, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setPreventSubmit(true);
      const response = await axios.post('/jobs/categories/', {
        name: state.name,
        cid: state.company,
      });
      if (response.status === 201) {
        removeAllToasts();
        successToast('Category added successfully!');
        if (onClose) {
          onClose();
        }
        if (onSuccess) {
          onSuccess(response);
        }
        return;
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Add Category.' });
    }
    setPreventSubmit(false);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Container mb="xs">
        <Title variant="darkGrey" fontWeight="500">
          Add new category
        </Title>
      </Container>
      <Container mb={activeCompany ? 'm' : 's'}>
        {!activeCompany && (
          <Label htmlFor="name" mb="xs">
            Category name
          </Label>
        )}
        <TextInput
          id="name"
          name="name"
          variant="minimal"
          placeholder="Category name"
          value={state.name}
          onChange={handleChange}
          pattern={ValidationPattern.extendedAlphanumeric}
          title="Please enter a valid category name"
          required
          autoFocus
        />
      </Container>
      {!activeCompany && (
        <Container mb="m">
          <Label htmlFor="company" mb="xs">
            Company
          </Label>
          <Select
            id="company"
            placeholder="Company"
            caretColor="primary"
            variant="minimal"
            options={companiesOptions}
            value={state.company}
            onChange={(option) =>
              handleChange({
                target: {
                  name: 'company',
                  value: option.value,
                },
              })
            }
            required
          />
        </Container>
      )}
      <Container flexDirection="row" justifyContent="flex-end" mt="xxs">
        <Button
          variant="contrast-primary"
          width="30%"
          disabled={preventSubmit}
          onClick={onClose}
          boxShadow="none"
          mr="s"
        >
          Close
        </Button>
        <Button type="submit" width={submitButtonWidth} disabled={preventSubmit}>
          {submitButtonText}
        </Button>
      </Container>
    </Form>
  );
};
